// extracted by mini-css-extract-plugin
export default {"header":"styles_header__qgj1b","headerToggle":"styles_headerToggle__+mZWb","phone":"styles_phone__CvAkk"};